import * as React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Divider from 'material-ui/Divider';

import { InlineGrid, InlineGridField } from '@components/form';

import { EventsFormCorrespodencesForm } from '@modules/events/EventsFormCorrespodencesForm';
import { correspondencesGridColumns } from '@modules/events/_eventsColumns';

const View: React.SFC<any> = ({ disabled }) => (
  <div>
    <Grid fluid={true}>
      <Row>
        <Col md={12}>
          <h4>Korespodence</h4>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <InlineGridField
            component={InlineGrid}
            name="correspondences"
            Form={EventsFormCorrespodencesForm}
            columns={correspondencesGridColumns}
            showCheckboxes={true}
            adding={!disabled}
            editing={!disabled}
            deleting={!disabled}
          />
        </Col>
      </Row>
    </Grid>

    <Divider />
  </div>
);

export default View;



// WEBPACK FOOTER //
// ./src/modules/events/EventsFormCorrespodences.tsx